import { render, staticRenderFns } from "./RegisterStep21.vue?vue&type=template&id=c0a47f5a&"
import script from "./RegisterStep21.vue?vue&type=script&lang=js&"
export * from "./RegisterStep21.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports